import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import classes from "./Modal.module.scss";
import RoundButton from "../Buttons/RoundButton";
import useFetch from "../../hooks/useFetch";
import * as api from "../../constants/api";
import Spinner from "../../components/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";

const ModalGroups = (props: any) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [newGroupName, setNewGroupName] = React.useState("");
  const [newGroupErrorMsg, setNewGroupErrorMsg] = React.useState("");
  const [newGroupSuccessMsg, setNewGroupSuccessMsg] = React.useState("");
  const [inactivateGroupSuccessMsg, inactivateNewGroupSuccessMsg] =
    React.useState("");
  // const [numberOfGroups, setNumberOfGroups] = React.useState(0);
  const [errorInactivateGroup, setErrorInactivateGroup] = React.useState("");
  const { textButton, buttonDesabled = false, companyId, hasNewGroups } = props;

  const handleNewGroup = (e: any) => {
    setNewGroupName(e.target.value);
  };
  const [groups, isLoading, fetchError, fetchCompanyGroups]: any = useFetch({
    autoInit: false,
  });

  const [
    ,
    isLoadinginactivateGroups,
    fetchErrorinactivateGroups,
    fetchinactivateGroups,
  ]: any = useFetch({
    autoInit: false,
  });
  const [, isLoadingNewGroup, fetchNewGroupError, fetchNewGroup]: any =
    useFetch({
      autoInit: false,
    });
  const sendNewGroup = () => {
    setNewGroupErrorMsg("");
    setNewGroupSuccessMsg("");
    if (newGroupName) {
      fetchNewGroup({
        method: "POST",
        url: api.API_USERS_POST_NEW_GROUP,
        data: { company_uid: companyId, group_name: newGroupName },
        onSuccess: () => {
          setNewGroupSuccessMsg(t("global.group_successfully_added"));
          getGroups();
          hasNewGroups();
        },
        onError: () => {
          setNewGroupErrorMsg(
            fetchNewGroupError?.data?.message
              ? t("global.error_add_new_group") +
              " " +
              t(
                "global." +
                fetchNewGroupError?.data?.message
                  .replace(/ /g, "_")
                  .replace("!", "")
                  .toLocaleLowerCase()
              )
              : t("global.default_error_add_new_group")
          );
        },
      });
    } else {
      setNewGroupErrorMsg(t("global.error_add_new_group_missing_name"));
    }
  };
  const getGroups = () => {
    setErrorInactivateGroup("");
    inactivateNewGroupSuccessMsg("");
    fetchCompanyGroups({
      method: "get",
      url: api.API_USERS_GROUPS_AUDIOFOCO(companyId),
      onSuccess: () => { },
      onError: () => { },
    });
  };
  const inactivateGrous = (groupId: any, groupName: any, companyUid: any) => {
    setErrorInactivateGroup("");
    inactivateNewGroupSuccessMsg("");
    if (groupId && groupName && companyUid) {
      const confirmMsg = t("global.confirm_del_msg");
      if (window.confirm(confirmMsg))
        fetchinactivateGroups({
          method: "PUT",
          url: api.API_USERS_POST_NEW_GROUP,
          data: {
            group_id: groupId,
            company_uid: companyId,
            group_name: groupName,
          },
          onSuccess: () => {
            inactivateNewGroupSuccessMsg(t("global.group_excluded"));
            getGroups();
            hasNewGroups();
          },
          onError: () => {
            setErrorInactivateGroup(
              t(
                fetchErrorinactivateGroups
                  ? "global." +
                  fetchErrorinactivateGroups?.data?.message
                    .replace(/ /g, "_")
                    .replace("!", "")
                    .toLocaleLowerCase()
                  : "Erro"
              )
            );
          },
        });
    }
  };
  useEffect(() => {
    getGroups();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
    getGroups();
  };
  const handleClose = () => {
    setOpen(false);
    props.setHasUserChangedGroup((value: boolean) => !value)
  };

  return (
    <>
      <RoundButton
        disabled={buttonDesabled}
        title={textButton}
        text={textButton}
        onClick={handleClickOpen}
        small
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className={classes.TextDialogPrimary}
        >
          {t("global.manage_groups")}
          <FontAwesomeIcon
            style={{ marginLeft: "60%", cursor: "pointer" }}
            icon={faRedo}
            onClick={() => {
              setNewGroupSuccessMsg("");
              getGroups();
            }}
          />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorInactivateGroup ? (
              <div className={classes.ErrorNewGroup}>
                {errorInactivateGroup}
              </div>
            ) : null}
            {newGroupSuccessMsg ? (
              <div className={classes.SuccessNewGroup}>
                {newGroupSuccessMsg}
              </div>
            ) : null}
            {inactivateGroupSuccessMsg ? (
              <div className={classes.SuccessNewGroup}>
                {inactivateGroupSuccessMsg}
              </div>
            ) : null}
            {isLoading ? (
              <Spinner />
            ) : groups ? (
              groups?.map(
                (group: any) =>
                  group.status === "active" && (
                    <div key={group.id} className={classes.Groups}>
                      <>{`${group.name}`}</>
                      <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        disabled={isLoadinginactivateGroups}
                        onClick={() =>
                          inactivateGrous(group.id, group.name, companyId)
                        }
                      >
                        {t("global.del_group")}
                      </Button>
                    </div>
                  )
              )
            ) : (
              <div>{t("global.no_groups")}</div>
            )}
            <DialogTitle
              id="alert-dialog-title"
              className={classes.TextDialogPrimary}
            >
              {t("global.add_group")}
            </DialogTitle>
            {newGroupErrorMsg ? (
              <div className={classes.ErrorNewGroup}>{newGroupErrorMsg}</div>
            ) : null}
            {newGroupSuccessMsg ? (
              <div className={classes.SuccessNewGroup}>
                {newGroupSuccessMsg}
              </div>
            ) : null}
            <form style={{ display: "flex", gap: "50px" }}>
              <label>{t("global.group_name")}</label>
              <input
                type="text"
                id="fname"
                name="fname"
                onChange={(e) => handleNewGroup(e)}
              />
              <Button
                variant="outlined"
                size="small"
                color="primary"
                onClick={sendNewGroup}
                disabled={isLoadingNewGroup}
              >{`Adicionar`}</Button>
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <>
            {/* <Button
              onClick={() => {
                alert(
                  `esse botão ainda não faz nada, 
                  mas vai levar para a página de 
                  cadastrar de grupos para vários usuários ao mesmo tempo`
                );
                handleClose();
              }}
              className={classes.TextDialogButtons}
              autoFocus
            >
              {t("global.to_manage_groups_page")}
            </Button> */}
            <Button
              onClick={handleClose}
              className={classes.TextDialogButtons}
              autoFocus
            >
              {t("global.close")}
            </Button>
          </>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalGroups;